function downPaymentText(raw) {
  return raw ? `Entrada de ${raw}%` : 'Sem entrada';
}

export default {
  methods: {
    downPaymentText,
  },
  filters: {
    downPaymentText,
  },
};
